<cm-card class="card">
    <cm-page-header class="page-name" [text]="headerTitle" [hideBackUrl]="true"></cm-page-header>
    <div class="fields">
        <ng-container *ngFor="let customEntry of fields; trackBy: trackCustomFieldByFn">
            <cm-instance-custom-group *ngIf="customEntry.fields" [name]="customEntry.name" class="group">
                <ng-template
                    *ngFor="let customField of customEntry.fields; trackBy: trackCustomFieldByFn"
                    [ngTemplateOutlet]="fieldTemplate"
                    [ngTemplateOutletContext]="{ $implicit: customField }"
                ></ng-template>
            </cm-instance-custom-group>

            <ng-container *ngIf="!customEntry.fields">
                <ng-template
                    [ngTemplateOutlet]="fieldTemplate"
                    [ngTemplateOutletContext]="{ $implicit: customEntry }"
                ></ng-template>
            </ng-container>
        </ng-container>
    </div>
</cm-card>

<ng-template #fieldTemplate let-customField>
    <ng-container [ngSwitch]="customField.type_id">
        <cm-instance-custom-field
            *ngSwitchCase="CUSTOM_FIELD_TYPES.SELECT_COUNTRY"
            [field]="customField"
            [readOnly]="isCustomFieldReadonly(customField)"
            (valueChange)="onValueChange(customField, $event)"
            [options]="countryOptions"
            class="field"
        ></cm-instance-custom-field>
        <cm-instance-custom-field
            *ngSwitchCase="CUSTOM_FIELD_TYPES.SELECT_STATE"
            [field]="customField"
            [readOnly]="isCustomFieldReadonly(customField)"
            (valueChange)="onValueChange(customField, $event)"
            [options]="stateOptions"
            class="field"
        ></cm-instance-custom-field>
        <cm-instance-custom-attachment
            *ngSwitchCase="CUSTOM_FIELD_TYPES.ATTACHMENT"
            [label]="customField.label"
            [files]="customField.value"
            [readOnly]="isCustomFieldReadonly(customField)"
            (upload)="onAttachmentUpload(customField, $event)"
            (remove)="onAttachmentRemove(customField, $event)"
            class="field"
        ></cm-instance-custom-attachment>
        <cm-instance-custom-field
            *ngSwitchDefault
            [field]="customField"
            [readOnly]="isCustomFieldReadonly(customField)"
            (valueChange)="onValueChange(customField, $event)"
            class="field"
        ></cm-instance-custom-field>
    </ng-container>
</ng-template>
